import { useState } from "react";
import Data from "../../data/certificates.json";

import CertificateCard from "./components/CertificateCard";

function Certificates() {
  const [active, setActive] = useState(Data[0]);

  return (
    <div className="my-3 container text-center">
      <div className="section-title">
        <h2 className="faq-heading d-flex flex-column flex-md-row justify-content-center"><b>5. Course Completion Certificate</b></h2>
        <p className="text-center mt-3 mb-5">
          Elevate your career with our esteemed certification. Unlock new opportunities and demonstrate your mastery in data science.
        </p>
      </div>
      <div className="d-flex justify-content-between justify-content-md-start text-left my-5 tabs">
        {
        Data.map(item => <button className={`btn ${active.id === item.id ? "active" : ""}`} onClick={() => setActive(item)}><h3 style={{ fontSize: '14px' }}>{item.label}</h3></button>)
        }  
      </div>
      <CertificateCard {...active} />
    </div>
  );
}
export default Certificates;
